export const HERO_CONSTANTS = {
  button: {
    label: "Build Your Network with Experts",
    link: "#contact-us",
  },
  title: "Expert-Led Network Design and Seamless Deployment",
};
